<template>
  <section v-if="getProductRelated[type] && getProductRelated[type].length > 0">
    <div class="row m0">
      <header class="col-md-12">
        <h2 class="heading cl-black mb20">
          <template v-if="isEmpty">
            {{ $t('Similar products') }}
          </template>
          <template v-else>
            {{ heading }}
          </template>
        </h2>
      </header>
    </div>
    <div class="row center-md m0">
      <div class="col-xs-12 related-section col-md-10 navigation-area">
        <products-carousel :products="getProductRelated[type]" :list="'related'" />
      </div>
    </div>
  </section>
</template>

<script>
import ProductsCarousel from 'theme/components/core/ProductsCarousel.vue'
// import ProductListing from 'theme/components/core/ProductListing'
import { mapGetters } from 'vuex'
import { prepareRelatedQuery } from '@vue-storefront/core/modules/catalog/queries/related'
import i18n from '@vue-storefront/i18n'
import config from 'config'
import bodybuilder from 'bodybuilder'

export default {
  name: 'Related',
  props: {
    type: {
      type: String,
      required: true
    },
    heading: {
      type: String,
      required: false,
      default: i18n.t('Similar products')
    },
    categoryId: {
      type: Number,
      required: false,
      default: null
    }
  },
  data () {
    return {
      isEmpty: false
    }
  },
  components: {
    // ProductListing,
    ProductsCarousel
  },
  beforeMount () {
    this.$bus.$on('product-after-load', this.refreshList)

    if (config.usePriceTiers) {
      this.$bus.$on('user-after-loggedin', this.refreshList)
      this.$bus.$on('user-after-logout', this.refreshList)
    }

    this.refreshList()
  },
  beforeDestroy () {
    if (config.usePriceTiers) {
      this.$bus.$off('user-after-loggedin', this.refreshList)
      this.$bus.$off('user-after-logout', this.refreshList)
    }
  },
  destroyed () {
    this.$bus.$off('product-after-load', this.refreshList)
  },
  methods: {
    refreshList () {
      let sku = this.getCurrentProduct.product_links ? this.getCurrentProduct.product_links
        .filter(pl => pl.link_type === this.type)
        .map(pl => pl.linked_product_sku) : []
      let key = 'sku'

      // if (sku === null || sku.length === 0) {
      //   if (this.type === 'related' && this.categoryId) {
      //     sku = [this.categoryId]
      //     key = 'category_ids'
      //   }
      // }
      let relatedProductsQuery = prepareRelatedQuery(key, sku)
      this.$store.dispatch('product/findProducts', {
        query: relatedProductsQuery,
        size: 20,
        sort: 'id:desc',
        prefetchGroupProducts: false,
        updateState: false
      }).then((response) => {
        if (!response) return

        let responseItems = response.items.filter(item => {
          return item.sku !== this.getCurrentProduct.parentSku && item.sku !== this.getCurrentProduct.sku
        })
        if (responseItems.length > 4 || this.type !== 'crosssell') {
          this.$store.dispatch('product/related', {
            key: this.type,
            items: responseItems
          })
          this.$forceUpdate()
        } else {
          // if (this.type !== 'crosssell') return

          let query
          query = bodybuilder()
          if (this.getCurrentProduct.color) query = query.filter('match', 'color', this.getCurrentProduct.color)
          if (this.getCurrentProduct.dress_length) query = query.filter('match', 'dress_length', this.getCurrentProduct.dress_length)
          if (this.type === 'crosssell' && this.categoryId) query = query.filter('terms', 'category_ids', [this.categoryId])

          query = query
            .filter('terms', 'visibility', [2, 3, 4])
            .filter('terms', 'status', [1])
            .filter('terms', 'stock.is_in_stock', [true])
            .build()

          relatedProductsQuery = prepareRelatedQuery(key, sku)
          this.$store.dispatch('product/findProducts', {
            query: query,
            size: 20 - responseItems.length,
            sort: 'id:desc',
            prefetchGroupProducts: false,
            updateState: false
          }).then((response) => {
            let nextRuleItems = response.items.filter(item => {
              return item.sku !== this.getCurrentProduct.parentSku && item.sku !== this.getCurrentProduct.sku && item.parentSku !== this.getCurrentProduct.parentSku
            })
            if (nextRuleItems) {
              this.$store.dispatch('product/related', {
                key: this.type,
                items: [...responseItems, ...nextRuleItems]
              })
            }
            this.$forceUpdate()
          })
        }
      })
    }
  },
  computed: {
    ...mapGetters({
      getProductRelated: 'product/getProductRelated',
      getCurrentProduct: 'product/getCurrentProduct'
    })
  }
}
</script>

<style lang="scss" scoped>
.navigation-area {
  padding: 0 40px;
  @media (max-width: 767px) {
    padding: 0 8px;
  }
}
.related-section {
  @media (min-width: 1920px) {
    max-width: 1650px;
  }
}
.heading {
  color: #333C39;
    margin-top: 25px;
    font-size: 40px;
    font-weight: 500;
    text-align: center;
  @media (max-width: 767px) {
    font-size: 28px;
  }
}
</style>
